import { ProductDetail } from './../../../model/products.model';
import { ProductsService } from './../../../services/products.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import * as DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

@Component({
  selector: 'app-product-update',
  templateUrl: './product-update.component.html',
  styleUrls: ['./product-update.component.scss']
})
export class ProductUpdateComponent implements OnInit, OnDestroy {
  productForm: FormGroup;
  product: any;
  public Editor = DecoupledEditor;

  public onReady(editor) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
  }
  private routerSubscriber: Subscription;
  handleSave() {
    console.log(Number(this.productForm.controls.price.value));
    if(this.validationData()){
      var productUpdate={
        content: this.productForm.controls.content.value,
        summary: this.productForm.controls.summary.value,
        title: this.productForm.controls.title.value,
        price: Number(this.productForm.controls.price.value),
        productCode:this.productForm.controls.productCode.value,
      }
    }
    // if(this.content.trim().length==0){
    //   return;
    // }
    // Tạm thời cho free
    this.productService.updateProduct(this.product.id,productUpdate).subscribe(res=>{
      this.router.navigate(["product"]);
    },err=>{
      console.log(err);
    });
  }
  validationData() {
    if (this.productForm.invalid)
      return false;
    return true;
  }
  constructor(private router: Router, private route: ActivatedRoute, private productService: ProductsService, private fb: FormBuilder) {
  }
  ngOnDestroy(): void {
    this.routerSubscriber.unsubscribe();
  }

  // public get form()  {
  //   return this.productForm.controls;
  // }

  ngOnInit() {
    // this.product=new Object();
    this.routerSubscriber = this.route.params.subscribe((params) => {
      const id = params.id;
      this.getProductDetail(id);
    });
    this.productForm = this.fb.group({
      //CKEDITOR
      content: ['', [Validators.required]],
      summary: ['', [Validators.required, Validators.maxLength(255)]],
      title: ['', [Validators.required, Validators.maxLength(255)]],
      price: [0, [Validators.required, Validators.min(0), Validators.pattern("[0-9.]*")]],
      productCode: ['0000'],
    });
  }
  getProductDetail(id: string) {
    this.productService.getProduct(id).subscribe((result: any) => {
      this.product = result;
      this.productForm.patchValue({
        content: result.content,
        summary: result.summary,
        title: result.title,
        price: result.price,
        productCode:result.productCode? result.productCode : '0000'
      })

    });
  }
  onSubmit() {

  }
  backToList() {
    this.router.navigate(['product'])
  }
}
